import moment from 'moment';

export const isConcreteHolidayDate = (value: string) =>
  /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  moment(value, 'YYYY-MM-DD', true).isValid();

export const publicHolidayDateForYear = (
  holidayDate: string,
  yearReference: moment.Moment
) => {
  if (isConcreteHolidayDate(holidayDate)) {
    return moment(holidayDate, 'YYYY-MM-DD');
  }

  const recurringDate = moment(holidayDate, 'DD-MM', true);
  if (recurringDate.isValid()) {
    return recurringDate.year(yearReference.year());
  }

  return moment.invalid();
};
